/**
 * @file Top-level React error boundary, around the router and providers' children.
 *
 * Catches what the router's own `defaultErrorComponent` cannot: a crash in the app shell, the auth
 * context or the router itself. Without it that is a blank white page.
 */
import { Component, type ReactNode } from "react";
import { ErrorCard } from "./ErrorCard";

interface State {
  readonly error: unknown;
  readonly failed: boolean;
}

export class AppErrorBoundary extends Component<{ readonly children: ReactNode }, State> {
  override state: State = { error: null, failed: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, failed: true };
  }

  override render(): ReactNode {
    if (this.state.failed) {
      return (
        <div className="flex min-h-dvh flex-col">
          <ErrorCard error={this.state.error} />
        </div>
      );
    }
    return this.props.children;
  }
}
